import { SimpleGrid, Box, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { GuestStatistics } from 'services/@types';

const statItems = [
  { key: 'total', label: 'Total Guests', color: 'brand' },
  { key: 'attending', label: 'Attending', color: 'green' },
  { key: 'declined', label: 'Declined', color: 'red' },
  { key: 'pending', label: 'Pending', color: 'orange' },
  { key: 'new', label: 'New', color: 'blue' },
  { key: 'checkedIn', label: 'Checked In', color: 'teal' },
] as const;

interface GuestStatsCardProps {
  stats: GuestStatistics;
}

export default function GuestStatsCard({ stats }: GuestStatsCardProps) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  return (
    <Card p="30px">
      <Text color={textColor} fontSize="xl" fontWeight="700" mb="20px">
        Guest Statistics
      </Text>
      <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} gap="16px">
        {statItems.map(({ key, label, color }) => (
          <Box
            key={key}
            p="16px"
            borderRadius="12px"
            bg={`${color}.50`}
            textAlign="center"
          >
            <Text fontSize="2xl" fontWeight="700" color={`${color}.500`}>
              {(stats as any)[key] ?? 0}
            </Text>
            <Text fontSize="xs" color="gray.500" fontWeight="600">
              {label}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
      {(stats.totalAdults != null || stats.totalChildren != null) && (
        <SimpleGrid columns={2} gap="16px" mt="12px" maxW="300px">
          <Box p="12px" borderRadius="10px" bg="gray.50" textAlign="center">
            <Text fontSize="lg" fontWeight="600" color={textColor}>
              {stats.totalAdults ?? 0}
            </Text>
            <Text fontSize="xs" color="gray.500">
              Adults
            </Text>
          </Box>
          <Box p="12px" borderRadius="10px" bg="gray.50" textAlign="center">
            <Text fontSize="lg" fontWeight="600" color={textColor}>
              {stats.totalChildren ?? 0}
            </Text>
            <Text fontSize="xs" color="gray.500">
              Children
            </Text>
          </Box>
        </SimpleGrid>
      )}
    </Card>
  );
}
